import { combineReducers } from '@reduxjs/toolkit';
import complaintAppComplaint from './complaint/reducers';

const rootReducer = combineReducers({
  complaintAppComplaint,
});

export default rootReducer;
